// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Element-module__element--llvIK {\n  position: relative;\n}\n", ""]);
// Exports
exports.locals = {
	"element": "Element-module__element--llvIK"
};
module.exports = exports;
